import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import { Button, makeStyles, useTheme } from '@material-ui/core';
import { ImcGenericStyle } from '../../ImcGeneric/ImcGenericStyle';
import { DATE_INIT, DATE_END } from '../../../../app/api-client/constants';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { UtilsDate } from '../../../../app/orussystem/utils/UtilDate';
import { BiSearch } from "react-icons/bi";

export default function AlcFilter({ idBascula, handlerFilter, isLoading, isDate, titlePanel = '', nameBascula, dataStartParam, dataEndParam }) {

  //let init_date = localStorage.getItem(DATE_INIT);
  //let end_date = localStorage.getItem(DATE_END);
  const history = useHistory();
  const [dataStart, setDataStart] = useState(dataStartParam);
  const [dataEnd, setDataEnd] = useState(dataEndParam);




  const classes = ImcGenericStyle();

  const handleDateChange = (date) => {
    setDataStart(date);
  };

  const handleDateEnd = (date) => {
    setDataEnd(date);
  };

  const handerSendFilter = () => {
    handlerFilter(dataStart, dataEnd)
  }

  const initDates = () => {

    if (!isDate) {
      let init = new Date();
      init = init.getTime();
      let end = init - 2629750000;
      end = new Date(end);
      let inD = init + 86400000;
      inD = new Date(inD);
      handlerFilter(end, inD)
      setDataStart(end)
      setDataEnd(new Date())
    } else {

      let init = new Date(dataStart);
      init = init.getTime();
      init = init + 86400000

      let end = new Date(dataEnd);
      end = end.getTime();
      end = end + 86400000

      setDataStart(new Date(init))
      setDataEnd(new Date(end))
    }

  }


  useEffect(() => {
    initDates();
  }, [])

  const handleLinkClick = () => {
    const dataStartFormatted = UtilsDate().formatYYYYMMdd(dataStart);
    const dataEndFormatted = UtilsDate().formatYYYYMMdd(dataEnd);

    let parametros = {
      nombre: nameBascula,
      dataStart: dataStartFormatted,
      dataEnd: dataEndFormatted,
      fechainicial: dataStart,
      fechafinal: dataEnd
    };

    history.push(`/basculas/alcoholimetria/reporte/${idBascula}`, parametros);
  };
  const theme = useTheme(); // Obtén el tema

  const primaryColor = theme.palette.primary.main;
  const iconStyle = {
    fill: primaryColor, // Establece el color primario como color de relleno (fill)
  };
  const customDatePickerMonthNavIcons = makeStyles((theme) => ({
    root: {
      '& .MuiSvgIcon-root': {
        fill: theme.palette.primary.main, // Cambia el color de los iconos de navegación de meses a primary
      },
    },
  }));
  const useStyles = makeStyles((theme) => ({
    icon: {
      color: theme.palette.primary.main, // Utiliza el color primario del tema
    },
  }));

  return (
    <>
      <Typography align="center" variant="h4" color='primary' style={{ fontWeight: 'bold' }} >{titlePanel}</Typography>

      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={4}>

          <Grid item xs={12} sm={4} md={4} >
            <KeyboardDatePicker
              type='fecha'
              disableToolbar
              variant="inline"
              format="yyyy-MM-dd"
              margin="normal"
              id="date-picker-inline"
              label="Fecha inicial"
              value={dataStart}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change date',

              }}
              className={customDatePickerMonthNavIcons().root}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={4} style={{ paddingRight: '3%' }}>
            <KeyboardDatePicker
              type='fecha'
              disableToolbar
              variant="inline"
              format="yyyy-MM-dd"
              minDate={dataStart}
              margin="normal"
              id="date-picker-inline"
              label="Fecha Final"
              value={dataEnd}
              onChange={handleDateEnd}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              className={customDatePickerMonthNavIcons().root}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={4} >

            <div className={classes.wrapper} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                onClick={() => handerSendFilter()}
                style={{ textTransform: "none", width: "auto", borderRadius: '10px' }}
              >
                <span style={{ marginRight: '8px' }}>Buscar</span> <BiSearch size={20} style={{ color: '#fff' }} />
              </Button>
            </div>

          </Grid>

        </Grid>

      </MuiPickersUtilsProvider>

    </>
  );
}
